import { useEffect, useRef, useState } from "react";
import "./App.css";
import recipeFinder from "./Appreact-theone.jpg";

function App() {
	const API_KEY = "8a04de73f61faaf84c3376ad3a3666ec";
	const APP_ID = "71f83033";

	const [recipes, setRecipes] = useState([]);
	const [loading, setLoading] = useState(false);
	const inputRef = useRef(null);

	const search = () => {
		// console.log("input ref>>>>", inputRef);
		searchForRecipe(inputRef.current.value);
		inputRef.current.value = "";
	};

	const searchForRecipe = (query) => {
		setLoading(true);
		let url = `https://api.edamam.com/search?q=${query}&app_id=${APP_ID}&app_key=${API_KEY}`;

		fetch(url)
			.then((res) => {
				return res.json();
			})
			.then((data) => {
				// console.log("data",data);
				setRecipes(data.hits);
				setLoading(false);
			})
			.catch((err) => {
				console.log("error", err);
				setLoading(false);
			});
	};

	useEffect(() => {
		searchForRecipe("Beef");
	}, []);

	return (
		<div className="App">
			<header className="App__header">
				<div className="App__image">
					<img src={recipeFinder} alt="recipe finder" />
				</div>
				<div className="App__search">
					<input ref={inputRef} type="text" placeholder="Search for a recipe" />
					<button onClick={search}>Search</button>
				</div>
				{loading && <p>Loading...</p>}
				<div className="App__wrapper">
					{recipes.map(({ recipe }, index) => {
						const { label, image, ingredientLines } = recipe;
						return (
							<div key={index} className="App__wrapper__recipe">
								<h3>{label}</h3>
								<img src={image} alt="Food" />

								<div className="App__steps">
									<h5>Steps</h5>
									{ingredientLines.map((step, index) => (
										<p key={index}>{step}</p>
									))}
								</div>
							</div>
						);
					})}
				</div>
			</header>
		</div>
	);
}

export default App;
